export const PAGE_SIZE = 10;

export const POST_MAX_LENGTH = 400;
